import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'upload-cloud';

const originalDimensions = {
    width: 24,
    height: 24,
};

export const IconUploadCloud = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'tertiary-400';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;

    return (
        <svg
            aria-labelledby={iconId}
            className={cx(addClasses)}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Upload Cloud Icon</title>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M5.747 13.043A6 6 0 1114.811 6.5h2.439a3.75 3.75 0 010 7.5h-9c-.962 0-1.84-.362-2.503-.957z"
                    fill={fill}
                    opacity=".3"
                />
                <path
                    d="M9.032 19.492h1.956V21.5a.5.5 0 00.5.5h1.024a.5.5 0 00.5-.5v-2.008h1.956a.5.5 0 00.382-.823l-2.968-3.505a.5.5 0 00-.764 0L8.65 18.669a.5.5 0 00.382.823z"
                    fill={fill}
                    opacity=".8"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
};
